export function appendUniqueQuickFilterTerms(baseText: string, additionalTerms: string): string {
  if (additionalTerms === '') {
    return baseText;
  }

  const existingTerms = new Set(baseText.split(/\s+/).filter(Boolean));
  const uniqueTerms = additionalTerms.split(/\s+/).filter(term => {
    if (term === '' || existingTerms.has(term)) {
      return false;
    }

    existingTerms.add(term);
    return true;
  });

  if (uniqueTerms.length === 0) {
    return baseText;
  }

  const appended = uniqueTerms.join(' ');
  return baseText === '' ? appended : `${baseText} ${appended}`;
}
